import { useEffect, useState } from "react";
import * as Yup from "yup";

const greekLettersRegex = /^[\u0370-\u03ff\u1f00-\u1fff0-9]+$/;

export const useValidateFields = (fields, isKYC) => {
    const [validation, setValidation] = useState({})
    useEffect(()=>{

        if (fields) {
            let fieldsForValidation = { ...fields }
            if (isKYC) {
                delete fieldsForValidation['occupation']
            }
            //filter items that need validation
            const requiredFieldsTags = Object.keys(fieldsForValidation).map((key) => { 
                if(fields[key].required && !fields[key].onlyGreek){
                    return (
                        {
                            [key]: Yup.string().required("Υποχρεωτικό πεδίο"),
                        }
                    )
                }else if(fields[key].required || fields[key].onlyGreek){
                    return (
                        {
                            [key]: Yup.string().matches(greekLettersRegex, "Μόνο ελληνικοί χαρακτήρες").required("Υποχρεωτικό πεδίο"),
                        }
                    )
                }
            }).filter(item => item !==undefined)

            const validationObject = requiredFieldsTags.reduce((result, current) => {
                const key = Object.keys(current)[0];
                result[key] = current[key];
                return result;
            }, {});

            setValidation(Yup.object().shape({
                ...validationObject
            }))
        }

    },[fields,isKYC])

    return validation;
}
